export default __webpack_public_path__ + "static/media/uniform&Jersey.2fd84530.JPG";